import React, { useEffect, useRef, useState } from "react";
import CreatePortalHOC from "../../Fields/CreatePortalHOC";
import NotesContent from "./NotesContent";
import CustomerNameViewNotes from "./CustomerNameViewNotes";
import useRequireAuth from "../../../../utils/useRequireAuth";
import { useFetchCommonDataQuery, useFetchTaskDataQuery } from "../../../../utils/customer/customerSelect";
// import AddIcon from "../../../Icons/AddIcon";
import { motion } from "framer-motion";
import CustomDrawer from "../../../UniversalComponents/CustomDrawer";
import { ReactComponent as CloseIcon } from "../../../../assets/images/crossIconAddTaskPodModal.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/images/searchBarIMG.svg";
import { ReactComponent as AddIcon } from "../../../../assets/images/icons/addIcon.svg";
import AddButton from "../../../UniversalComponents/AddButton";
import useClickOutside from "../../../../hooks/Screen/useClickOutside";
import MotionSearchBox from "../../../UniversalComponents/MotionSearchBox";
import NotesContentPreivew from "../ExtraComponent/NotesContentPreivew";
import { Dialog } from "@mui/material";
import { Category } from "@mui/icons-material";
import CustomerNameNotesEditor from "./CustomerNameNotesEditor";

const NotesModal = ({
  isOpen,
  closenotesoutsideclick,
  Item,
  handleCloseNotes,
  notesData,
  refreshKey,
  viewNotes,
  setNotesSetting,
  notesSetting,
  handleNotesClick,
  textareaRef,
  selectedFiles,
  resetFile,
  handleSubmit,
  handleInputChange,
  formData,
  handleSetColour,
  initialContent,
  setInitialContent,
  handleFileUpload,
  handleClickDeleteFile,
  customerColor,
  refetchNotesData,
  // setState for preview page
  setFormData,
  setColor,
  setSelectedFiles,
  setAddNotes,
  addNotes,
  selectedOptions,
  setSelectedOptions,
  sectionType = "Tracking",
  rawNotesData,
  isCustomModule,
}) => {
  const { token } = useRequireAuth();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPinnedDrawerOpen, setIsPinnedDrawerOpen] = useState(false);
  const [filterNoteId, setFilterNoteId] = useState(null);
  const [previewNote, setPreviewNote] = useState(false);
  // const { data: customerTaskCategory } = useFetchTaskDataQuery({
  //   token,
  //   jsonData: { customer_id: Item?.id, company_id: Item?.company_id },
  // });
  const { data: customerTaskCategory, error, isLoading: commonDataLoading } = useFetchCommonDataQuery();
  // const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState("Tomorrow");
  const [selectedContent, setSelectedContent] = useState("Task");
  const [selectedList, setSelectedList] = useState([]);

  const noteMain = useRef();
  const dialogClose = useRef();

  const handleEditNote = () => {
    setAddNotes(!addNotes);
    setPreviewNote(false);
    const noteFilterData = notesData?.filter((item) => item.id == filterNoteId);
    setColor(noteFilterData[0]?.colour_code);

    setFormData({
      id: noteFilterData[0]?.id || "",
      notes_title: noteFilterData[0]?.notes_title || "",
      notes_category_id:
        customerTaskCategory?.data?.notes.find((category) => category.value === noteFilterData[0]?.category_name)?.id ||
        "",
      colour_code: noteFilterData[0]?.colour_code || "",
      notes_body: noteFilterData[0]?.notes_body || "",
    });
    setSelectedFiles(noteFilterData[0]?.attachments || []);
  };

  const OpenAddEditDrawer = () => {
    setAddNotes("new");
    setColor("");
    setFormData({
      notes_title: "",
      notes_category_id: "",
      colour_code: "",
    });
    setSelectedFiles([]);
    setSelectedOptions([]);
  };
  // const handleOutsideClick = (event) => {
  //   if (dialogClose.current && !dialogClose.current.contains(event.target)) {
  //    handleEditNote();
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener("click", handleOutsideClick);
  //   return () => {
  //     document.removeEventListener("click", handleOutsideClick);
  //   };
  // }, []);

  const HandlePreviewData = (id) => {
    setFilterNoteId(id);
    setPreviewNote(!previewNote);
  };

  const handleOptionClick = (options, isRemove) => {
    if (isRemove) {
      const updatedOptions = selectedOptions.filter((option) => option.value !== options.value);
      setSelectedOptions(updatedOptions);
    } else setSelectedOptions(options);
  };

  return (
    <CustomDrawer open={isOpen} onClose={handleCloseNotes} showSubDrawer={isPinnedDrawerOpen}>
      <div className="h-full w-full flex flex-col bg-[#fff]" ref={noteMain}>
        <div className="pl-4 flex w-full justify-between items-center py-2 border-b border-BECBD3 ">
          <div className="flex items-center grow min-w-0">
            <span className="mr-2 flex">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 14 19" fill="none">
                <path
                  d="M11.4945 0.5H2.50551C1.12176 0.5 0 1.6889 0 3.15547V15.8445C0 17.3111 1.12176 18.5 2.50551 18.5H11.4945C12.8782 18.5 14 17.3111 14 15.8445V3.15547C14 1.6889 12.8782 0.5 11.4945 0.5ZM4.93004 5.52294H9.06992C9.38924 5.52266 9.6483 5.79682 9.64857 6.13526C9.64883 6.47369 9.39015 6.7483 9.07083 6.74854H4.93004C4.61072 6.74854 4.35185 6.47417 4.35185 6.13574C4.35185 5.7973 4.61072 5.52294 4.93004 5.52294ZM10.5597 13.4771H3.44025C3.12093 13.4771 2.86206 13.2027 2.86206 12.8643C2.86206 12.5259 3.12093 12.2515 3.44025 12.2515H10.5597C10.8791 12.2515 11.1379 12.5259 11.1379 12.8643C11.1379 13.2027 10.8791 13.4771 10.5597 13.4771ZM10.5597 10.1128H3.44025C3.12093 10.1128 2.86206 9.83844 2.86206 9.5C2.86206 9.16156 3.12093 8.8872 3.44025 8.8872H10.5597C10.8791 8.8872 11.1379 9.16156 11.1379 9.5C11.1379 9.83844 10.8791 10.1128 10.5597 10.1128Z"
                  fill="#1D4469"
                />
              </svg>
            </span>
            <p className="truncate text-nowrap">{Item?.customer_name}</p>
          </div>

          <div className="flex gap-1 items-center justify-between me-2">
            <div
              className="rounded-[5px] w-[30px] h-[30px] flex justify-center items-center cursor-pointer"
              onClick={handleCloseNotes}
            >
              <CloseIcon />
            </div>
          </div>
        </div>

        {addNotes && (
          // <div className={`notes my-2 px-3 ${Object.values(viewNotes).some((value) => value) ? "show" : ""}`}>
          <Dialog open={addNotes} fullWidth maxWidth={"md"}>
            <CustomerNameViewNotes
              key={refreshKey}
              setNotesSetting={setNotesSetting}
              notesSetting={notesSetting}
              handleNotesClick={handleNotesClick}
              textareaRef={textareaRef}
              visible={viewNotes.addnotes}
              selectedFile={selectedFiles}
              resetFile={resetFile}
              customerTaskCategory={customerTaskCategory}
              customerColor={customerColor}
              handleSubmit={(e) => {
                handleSubmit(e);
                setIsPinnedDrawerOpen(false);
              }}
              handleInputChange={handleInputChange}
              formData={formData}
              handleSetColour={handleSetColour}
              setAddNotes={setAddNotes}
              handleEditNote={handleEditNote}
              addNotes={addNotes}
              setFormData={setFormData}
              notesData={notesData?.filter((item) => item.id == filterNoteId)}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              handleOptionClick={handleOptionClick}
            >
              <div
                className={`min-h-0 grow flex flex-col w-full items-start justify-between border rounded-b-md border-t-0 ${viewNotes.addnotes ? "show" : "hidden"}`}
              >
                <CustomerNameNotesEditor
                  key={refreshKey}
                  textareaRef={textareaRef}
                  initialContent={initialContent}
                  setInitialContent={setInitialContent}
                  notesSetting={notesSetting}
                  handleFileUpload={handleFileUpload}
                  selectedFile={selectedFiles}
                  hndleCloseNotes={handleCloseNotes}
                  handleClickDeleteFile={handleClickDeleteFile}
                  addNotes={addNotes}
                  setAddNotes={setAddNotes}
                  handleEditNote={handleEditNote}
                  formData={formData}
                  notesData={notesData?.filter((item) => item.id == filterNoteId)}
                  setSelectedFiles={setSelectedFiles}
                  resetFile={resetFile}
                  refetchNotesData={refetchNotesData}
                  selectedOptions={selectedOptions}
                  handleOptionClick={handleOptionClick}
                  setSelectedOptions={setSelectedOptions}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  selectedContent={selectedContent}
                  setSelectedContent={setSelectedContent}
                />
              </div>
            </CustomerNameViewNotes>
          </Dialog>
          // </div>
        )}

        <NotesContent
          handleEditNote={handleEditNote}
          notesData={notesData}
          refetchNotesData={refetchNotesData}
          searchTerm={searchTerm}
          key={refreshKey}
          setIsPinnedDrawerOpen={setIsPinnedDrawerOpen}
          noteMain={noteMain}
          // for search and add button
          isSearchActive={isSearchOpen}
          setIsSearchActive={setIsSearchOpen}
          searchText={searchTerm}
          setSearchText={setSearchTerm}
          isActive={addNotes}
          HandlePreviewData={HandlePreviewData}
          OpenAddEditDrawer={OpenAddEditDrawer}
          sectionType={sectionType}
          rawNotesData={rawNotesData}
          isCustomModule={isCustomModule}
          Item={Item}
        />

        {previewNote && (
          <Dialog open={previewNote} fullWidth maxWidth={"md"}>
            <NotesContentPreivew
              handleEditNote={handleEditNote}
              notesData={notesData?.filter((item) => item.id == filterNoteId)} // filter for unique note
              refetchNotesData={refetchNotesData}
              searchTerm={searchTerm}
              key={refreshKey}
              setIsPinnedDrawerOpen={setIsPinnedDrawerOpen}
              noteMain={noteMain}
              // for search and add button
              isSearchActive={isSearchOpen}
              setIsSearchActive={setIsSearchOpen}
              searchText={searchTerm}
              setSearchText={setSearchTerm}
              HandlePreviewData={HandlePreviewData}
              setPreviewNote={setPreviewNote}
              previewNote={previewNote}
              isEditable
              sectionType={sectionType}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              selectedContent={selectedContent}
              setSelectedContent={setSelectedContent}
              selectedList={selectedList}
              setSelectedList={setSelectedList}
              isCustomModule={isCustomModule}
              Item={Item}
            />
          </Dialog>
        )}
      </div>
    </CustomDrawer>
  );
};

export default NotesModal;
